import { BarChart, ListBarChart, StudenteGraficoDTO } from './../../../model/newModel';
import { StatisticheService } from './statistiche.service';
import { Component, AfterViewInit, OnInit } from '@angular/core';
import * as Prism from 'prismjs';
import { Router } from '@angular/router';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractListComponent } from '../../../model/AbstractListComponent';
import {
  InstructorOrTutorDTO,
  ListLogOperazioneDTO,
  ListStudenteGraficoDTO,
  UtenteDTO,
} from 'src/app/model/newModel';
import { SelectDTO } from '../../../model/newModel';
import { SharedService } from '../../../shared/shared.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-statistiche',
  templateUrl: './statistiche.component.html',
  styleUrls: ['./statistiche.component.css'],
})
export class StatisticheComponent
  extends AbstractListComponent
  implements AfterViewInit, OnInit {
  goToPage(idVaiA: string, event: any) {
    throw new Error('Method not implemented.');
  }
  nextPage(skip: number, take: number, count: number, offset?: number) {
    throw new Error('Method not implemented.');
  }
  previousPage(skip: number, take: number, offset?: number) {
    throw new Error('Method not implemented.');
  }
  statistiche: ListStudenteGraficoDTO;
  idSessioneOla: string[];

  visibleChart: ListBarChart;

  labelsBarChart: String[];
  dataBarChart: BarChart[];

  switchGrafico: boolean;

  mapTable: StudenteGraficoDTO[][];

  mapPass: StudenteGraficoDTO[];
  mapAss: StudenteGraficoDTO[];
  mapFail: StudenteGraficoDTO[];

  dataPieChart: any[];

  listBarChart: ListBarChart[];


  sessioniOla: SelectDTO[];
  labelsSessioniOla: String[];
  showStatistiche = false;
  ngOnInit(): void {
    super.ngOnInit();
    this.loadSessioniOla();
  }

  getStatistiche(idSessioneOla: any) {
    if (!idSessioneOla) {
      this.sharedService.openWarningModal(
        'Selezionare una sessione ola per recuperare le statistiche'
      );
    } else {
      this.spinner.show();
      this.statisticheService.getStatistiche(idSessioneOla).subscribe(
        (res) => {
          this.visibleChart = new ListBarChart();
          this.visibleChart.label = [];
          this.switchGrafico = true;
          this.statistiche = res;
          this.creaStatistiche();
          this.showStatistiche = true;
          this.spinner.hide();
        },
        (error) => {
          console.log('Errore search');
          this.spinner.hide();
        }
      );
    }
  }

  getStatisticheExcel(idSessioneOla: number) {
    if (!idSessioneOla) {
      this.sharedService.openWarningModal(
        'Selezionare una sessione ola per recuperare le statistiche'
      );
    } else {
      this.spinner.show();
      this.statisticheService.getStatisticheExcel(idSessioneOla).subscribe(
        (result) => {
          const downloadURL = window.URL.createObjectURL(result);
          const link = document.createElement('a');
          link.href = downloadURL;
          link.download = 'statistiche.csv';
          link.click();
          this.spinner.hide();
        },
        (error) => {
          console.log('Errore excel');
          this.spinner.hide();
        }
      );
    }
  }

  creaStatistiche() {
    this.findViewValue();
    this.dataBarChart = [];
    this.labelsBarChart = [];
    this.listBarChart = [];
    this.dataPieChart = [];
    this.mapPass = [];
    this.mapFail = [];
    this.mapAss = [];
    const pass = [];
    const bocc = [];
    const ass = [];

    this.mapTable=_.map(
      _.groupBy(this.statistiche.listStudentiGraficoDTO, 'nomeCorsoDiLaurea')
    )
    this.mapTable.forEach((s) => {
      let passCount = 0;
      let boccCount = 0;
      let assCount = 0;
      let count = 0;
      s.forEach((v) => {
        if (v.votoProva != null) {
          count++;
          if (v.votoProva>=v.sogliaGruppo) {
            passCount++;
            this.mapPass.push(v);
          } else if (v.votoProva == 0) {
            assCount++;
            this.mapAss.push(v);
          } else {
            boccCount++;
            this.mapFail.push(v);
          }
        }
      });
      if(passCount!=0 || boccCount!=0 || assCount!=0){
        const passFailCount = passCount + boccCount;
        pass.push(((passCount * 100) / passFailCount).toFixed(1));
        bocc.push(((boccCount * 100) / passFailCount).toFixed(1));
        ass.push(((assCount * 100) / count).toFixed(1));
        this.labelsBarChart.push(s[0].nomeCorsoDiLaurea);

        this.dataPieChart.push(passCount);

        const temp = new ListBarChart();
        const tempPass = new BarChart();
        const tempBocc = new BarChart();
        const tempAss = new BarChart();
        const tempDataBar = [];
        const tempPassValue = [];
        const tempBoccValue = [];
        const tempAssValue = [];
        tempPass.label = 'Pass';
        tempPassValue.push(((passCount * 100) / passFailCount).toFixed(1));
        tempPass.data = tempPassValue;
        tempBocc.label = 'Bocc';
        tempBoccValue.push(((boccCount * 100) / passFailCount).toFixed(1));
        tempBocc.data = tempBoccValue;
        tempAss.label = 'Ass';
        tempAssValue.push(((assCount * 100) / count).toFixed(1));
        tempAss.data = tempAssValue;
        tempDataBar.push(tempPass);
        tempDataBar.push(tempBocc);
        tempDataBar.push(tempAss);

        const templabel = [];
        templabel.push(s[0].nomeCorsoDiLaurea);
        temp.label = templabel;
        temp.barChart = tempDataBar;
        this.listBarChart.push(temp);
      }
    });
    const bcPass = new BarChart();
    const bcBocc = new BarChart();
    const bcAss = new BarChart();
    bcPass.label = 'Pass';
    bcPass.data = pass;
    this.dataBarChart.push(bcPass);
    bcBocc.label = 'Fail';
    bcBocc.data = bocc;
    this.dataBarChart.push(bcBocc);
    bcAss.label = 'Absent';
    bcAss.data = ass;
    this.dataBarChart.push(bcAss);
  }

  /**
   * @method ngAfterViewInit
   */
  ngAfterViewInit() {
    Prism.highlightAll();
  }

  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    public router: Router,
    private spinner: NgxSpinnerService,
    private sharedService: SharedService,
    private statisticheService: StatisticheService

  ) {
    super();
    this.labelsBarChart = new Array();
    this.dataBarChart = new Array();
  }

  loadSessioniOla() {
    this.sharedService.selectSessioniOla(false).subscribe(
      (result) => {
        this.sessioniOla = result.list;
      },
      (error) => {
        console.log('Errore selectSessioniOla');
      }
    );
  }

  findViewValue(){
    this.labelsSessioniOla = []
    this.sessioniOla.forEach(sessione => {
      if (this.idSessioneOla.includes(sessione.value)){
        this.labelsSessioniOla.push(sessione.viewValue)
      }
    });
  }
}
